import {combineReducers} from 'redux';
import {managementReducer} from './management';

export const olxImportReducer = combineReducers({
  management: managementReducer,
});
